// Gegenereerd bestand - NIET BEWERKEN!
// WEL inchecken in Git!

export enum DagrapportStatus {
    DagrapportAfgerond = 'dagrapportAfgerond',
    DagrapportGeannuleerd = 'dagrapportGeannuleerd',
    DagrapportGedeeltelijkAfgerond = 'dagrapportGedeeltelijkAfgerond',
    DagrapportGepland = 'dagrapportGepland',
    DagrapportGestart = 'dagrapportGestart',
    DagrapportRegen = 'dagrapportRegen',
    DagrapportVerwerkt = 'dagrapportVerwerkt',
}
